import './phonics.scss';
import { setupLayout } from '../../Shared/layout';
import { setupSideStudentPerformance } from '../../Shared/Component/SideStudentPerformance/side-student-performance';
import { setupEnquiryForm, EnquiryFormType } from '../../Shared/Component/EnquiryForm/enquiry-form';

setupLayout();
setupSideStudentPerformance();
setupEnquiryForm(EnquiryFormType.Course);
